import { useEffect, useState } from 'react';

// 右クリックで表示するコンテキスト メニュー用カスタム フック。

// 参照: https://blog.logrocket.com/creating-react-context-menu/
// In the useContexMenu Hook, we declare two states: clicked and points. Then, we use the useEffect Hook to register an event listener and clean up the event with the cleanup function. Lastly, clicked, setClicked, points, and setPoints are returned.
const useContextMenu = () => {
  const [clicked, setClicked] = useState(false);
  const [points, setPoints] = useState({
    x: 0,
    y: 0,
  });

  useEffect(() => {
    const handleClick = () => setClicked(false);
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);

  return {
    clicked,
    setClicked,
    points,
    setPoints,
  };
};

export default useContextMenu;
